/* Lavender Farm Simulator — loads the Farm Arcade games (~250 KB) and the Lavender Circuit board (~85 KB) only when needed:
   the first time a player heads to Arcade or Farm Circuit, or once the page has been idle for a while.
   Everything else on the page starts sooner because these are no longer in the first download. */
(function () {
  'use strict';
  if (window.__gllfLazy) return; window.__gllfLazy = true;
  var me = document.currentScript, cfg = me ? me.dataset : {};
  var PACKS = {
    arcade: { css: [cfg.arcadeCss], js: [cfg.arcadeEngine, cfg.arcadeA, cfg.arcadeB, cfg.arcadeC, cfg.arcadeD] },
    circuit: { css: [cfg.circuitCss], js: [cfg.circuitJs] }
  };
  var done = {};
  function load(name) {
    var p = PACKS[name]; if (!p || done[name]) return; done[name] = true;
    p.css.forEach(function (u) { if (!u) return; var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = u; document.head.appendChild(l); });
    p.js.forEach(function (u) { if (!u) return; var s = document.createElement('script'); s.src = u; s.async = false; document.head.appendChild(s); });
  }
  function want(v) { v = String(v || ''); if (v === 'arcade') load('arcade'); else if (v === 'circuit') load('circuit'); }
  function root() { return document.getElementById('lfg-simulator-root'); }
  function visible(v) { var r = root(), s = r && r.querySelector('section.lfg-view[data-view="' + v + '"]'); return !!(s && !s.hidden && s.offsetParent); }
  /* start early on hover/touch of the tab, so it is usually ready by the time the click lands */
  ['pointerdown', 'mouseover', 'focusin', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var t = e.target.closest && e.target.closest('[data-tab="arcade"],[data-tab="circuit"]'); if (t) want(t.getAttribute('data-tab')); }, { capture: true, passive: true });
  });
  document.addEventListener('lfg:route-enter', function (e) { want(e.detail && e.detail.route); }, true);
  var n = 0;
  (function check() {
    if (visible('arcade')) load('arcade'); if (visible('circuit')) load('circuit');
    if (!(done.arcade && done.circuit) && ++n < 40) setTimeout(check, 500);
  })();
  function idle() { load('circuit'); load('arcade'); }
  window.addEventListener('load', function () { setTimeout(function () { if (window.requestIdleCallback) requestIdleCallback(idle, { timeout: 4000 }); else idle(); }, 9000); });
  window.GLLFLazy = { load: load, loaded: done };
})();
/* Simulator add-ons loaded right away from the same theme assets folder as this file:
   gllf-sim-toolbar  — tool belt arrows, touch drag, white belt by day, Apiary belt, field weather row fix
   gllf-sim-loadbar  — lavender "Opening Greenhouse…" loading bar while an area draws
   gllf-sim-tabjump  — lands on the playable part (map, field, beds, hives) when a work area opens
   gllf-sim-bugfix   — level-100 sweep fixes: squeezed layouts (Academy, Barn, Travel…), unreadable text */
(function () {
  'use strict';
  var me = document.currentScript, src = me && me.src ? me.src : '';
  if (!src || window.__gllfSimAddonLoader) return; window.__gllfSimAddonLoader = true;
  var v = '?v=' + Math.floor(Date.now() / 36e5);
  ['gllf-sim-toolbar.js', 'gllf-sim-loadbar.js', 'gllf-sim-tabjump.js', 'gllf-sim-bugfix.js'].forEach(function (f) {
    /* normally already loaded by the theme snippet (versioned by Shopify); this is only a fallback */
    if (document.querySelector('script[src*="/' + f + '"]')) return;
    var s = document.createElement('script');
    s.src = src.replace(/gllf-sim-lazy\.js[^]*$/, f + v); s.async = false;
    document.head.appendChild(s);
  });
})();
